import React, { useState } from 'react';
import HorizontalTabsContainer from 'chameleon/ui-stack/ui/page/horizontal-tabs-container';
import HorizontalTabs from 'chameleon/ui-stack/ui/base/tabs/horizontal-tabs';
import { TrendDataFilterHelper } from 'chameleon/src/components/TrendReportingContainer/utils';

const Tabs = ({ defaultTab, onTabChange }) => {
  const [resourceType, setResourceType] = useState(defaultTab || 'all');

  return (
    <HorizontalTabsContainer
      leftContainer={
        <HorizontalTabs
          tabs={TrendDataFilterHelper.TYPE_FILTERS.map(({ name, value }) => ({
            name,
            onClick: () => {
              setResourceType(value);
              onTabChange(value);
            },
            isActive: value === resourceType,
          }))}
          accessibility={{
            ariaLabel: 'Trend Reporting tabs',
          }}
        />
      }
    />
  );
};

export default Tabs;
